import { entity, equals, query, string } from '~/prix'
import asGeoJson from '~/prix/functions/asGeoJson'

export default function microRegionsQuery(
  by: 'microRegionId' | 'mesoRegionId' | 'stateId',
  id: string,
) {
  switch (by) {
    case 'microRegionId':
      return query('microRegion')
        .select({
          id: entity('microRegion').property('id'),
          name: entity('microRegion').property('name'),
          boundary: asGeoJson(entity('microRegion').property('lowerQualityBoundary')),
          center: asGeoJson(entity('microRegion').property('center')),
          stateId: entity('state').property('id'),
        })
        .join({
          current: entity('microRegion').property('mesoRegionId'),
          target: entity('mesoRegion').property('id'),
        })
        .join({
          current: entity('mesoRegion').property('stateId'),
          target: entity('state').property('id'),
        })
        .where(equals(entity('microRegion').property('id'), string().value(id)))
        .limit(1)
    case 'mesoRegionId':
      return query('microRegion')
        .select({
          id: entity('microRegion').property('id'),
          name: entity('microRegion').property('name'),
          boundary: asGeoJson(entity('microRegion').property('lowerQualityBoundary')),
          center: asGeoJson(entity('microRegion').property('center')),
        })
        .where(equals(entity('microRegion').property('mesoRegionId'), string().value(id)))
        .limit(10000)
    case 'stateId':
      return query('microRegion')
        .select({
          id: entity('microRegion').property('id'),
          name: entity('microRegion').property('name'),
          boundary: asGeoJson(entity('microRegion').property('lowerQualityBoundary')),
          center: asGeoJson(entity('microRegion').property('center')),
        })
        .join({
          current: entity('microRegion').property('mesoRegionId'),
          target: entity('mesoRegion').property('id'),
        })
        .where(equals(entity('mesoRegion').property('stateId'), string().value(id)))
        .limit(10000)
    default:
      throw new Error(`Invalid by: ${by} on microRegions query`)
  }
}
